import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './PlanSubscriptions.Styles';

const PlanSubscriptions = ({ i18nKey, subscriptions, subscriptionsTextStyle, ...props }) => {
  const theme = useTheme();
  const subs = _map(subscriptions, (subscription, index) => {
    return <Icon style={styles.SubscriptionIcon} name={subscription} type="image" key={index} />;
  });
  return (
    <View style={styles.SubscriptionContainer} {...props}>
      <VFText style={[styles.SubscriptionText(theme), subscriptionsTextStyle]} i18nKey={i18nKey} />
      <View style={styles.SubscriptionIconsContainer}>{subs}</View>
    </View>
  );
};

PlanSubscriptions.propTypes = {
  i18nKey: PropTypes.string,
  subscriptions: PropTypes.array,
  subscriptionsTextStyle: PropTypes.object,
};
export default PlanSubscriptions;
